import { useState } from 'react';
import useClient from 'api/client';
import { useParams } from 'react-router-dom';
import { useAlert } from 'components/message/AlertContext';
import archiveEnvironment from 'api/Environment/archiveEnvironment';

export default function useArchiveEnvironment() {
    const client = useClient();
    const params = useParams<{ uri: string }>();
    const { openAlert } = useAlert();
    const [deleteLoading, setDeleteLoading] = useState(false);

    const handleArchiveEnvironment = async () => {
        try {
            setDeleteLoading(true);
            if (params.uri) {
                const response = await client.mutate(
                    archiveEnvironment(params.uri),
                );
                if (!response.errors) {
                    openAlert({
                        message: `Environment succesfully archived`,
                        severity: 'success',
                        path: '/environments',
                    });
                } else {
                    openAlert({
                        message: `Could not archive environment, received ${response.errors[0]?.message}`,
                        severity: 'alert',
                    });
                }
            }
        } finally {
            setDeleteLoading(false);
        }
    };

    return {
        handleArchiveEnvironment,
        deleteLoading,
    };
}
